import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

export const WriterlyAuthLayout = ({ leftContent, rightContent }) => {
  const mobileView = useMediaQuery('(max-width: 834px)');
  const { pathname } = useLocation();
  return (
    <div className="flex w-full h-screen bg-white">
      <div
        className={`w-full flex items-center justify-center ${
          pathname.includes('join-your-team') ? 'xl:w-1/3' : 'xl:w-1/4'
        } lg:w-1/2 md:w-1/2 overflow-auto`}
        data-testid={'auth-leftContent'}
      >
        {leftContent}
      </div>
      <div
        className={`w-1/2 relative bg-backgroundAuth1 bg-no-repeat bg-cover h-full ${
          mobileView ? 'hidden' : 'block'
        } ${
          pathname.includes('join-your-team') ? 'xl:w-2/3' : 'xl:w-3/4'
        } 2xl:w-3/4 lg:flex items-center justify-center overflow-auto`}
        data-testid={'auth-rightContent'}
      >
        {rightContent}
      </div>
    </div>
  );
};

WriterlyAuthLayout.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
};
